// extracted by mini-css-extract-plugin
export default {"expandButton":"expandButton_TmdG","expandButtonIcon":"expandButtonIcon_i1dp"};